.embed {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--nexus-space-lg);
  margin: var(--nexus-space-xl) 0;
  padding: var(--nexus-space-xl);
  border: 1px solid var(--nexus-border);
  border-radius: var(--nexus-radius-surface);
  background: var(--nexus-surface);
  font-size: var(--nexus-text-base);
  line-height: var(--nexus-leading-normal);
}

.head {
  display: flex;
  justify-content: space-between;
}

.label {
  font-size: var(--nexus-text-xs);
  font-weight: var(--nexus-weight-semibold);
  letter-spacing: var(--nexus-tracking-wider);
  text-transform: uppercase;
  color: var(--nexus-text-muted);
}

.live {
  composes: label;
  color: var(--nexus-danger);
}

.scoreline {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: var(--nexus-space-lg);
}

.side {
  display: flex;
  align-items: center;
  gap: var(--nexus-space-md);
  min-width: 0;
  color: var(--nexus-text-secondary);
}

.end {
  flex-direction: row-reverse;
  text-align: right;
}

.winner {
  color: var(--nexus-text);
}

.team {
  font-weight: var(--nexus-weight-semibold);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.score {
  font-family: var(--nexus-font-display);
  font-variation-settings: var(--nexus-display-settings);
  font-size: var(--nexus-text-4xl);
  line-height: 1;
  white-space: nowrap;
}

.foot {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--nexus-space-sm);
  padding-top: var(--nexus-space-md);
  border-top: 1px solid var(--nexus-border);
  font-size: var(--nexus-text-sm);
  color: var(--nexus-text-muted);
}

/* Doubled class so article link styles (.content a) don't restyle it. */
.embed .more {
  font-weight: var(--nexus-weight-semibold);
  color: var(--news-accent, var(--nexus-primary));
  text-decoration: none;
}

[data-theme="light"] .embed .more {
  color: var(--news-accent-light, var(--news-accent, var(--nexus-primary-active)));
}

.embed .more:hover {
  text-decoration: underline;
}

.player {
  display: flex;
  align-items: center;
  gap: var(--nexus-space-lg);
}

.playerText {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.playerName {
  font-family: var(--nexus-font-display);
  font-variation-settings: var(--nexus-display-settings-soft);
  font-size: var(--nexus-text-2xl);
  line-height: 1.1;
}

.handle {
  font-size: var(--nexus-text-sm);
  color: var(--nexus-text-muted);
}

.trust {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--nexus-space-xs);
}

.level {
  font-size: var(--nexus-text-xs);
  font-weight: var(--nexus-weight-semibold);
  letter-spacing: var(--nexus-tracking-wide);
  text-transform: uppercase;
  color: var(--nexus-text-secondary);
}

/* Doubled class so article list styles (.content ul/li) don't indent it. */
.embed .segments {
  display: flex;
  flex-direction: column;
  gap: var(--nexus-space-sm);
  margin: 0;
  padding: 0;
  list-style: none;
}

.embed .segment {
  margin: 0;
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr) 56px;
  align-items: center;
  gap: var(--nexus-space-md);
  font-size: var(--nexus-text-sm);
}

.segmentLabel {
  color: var(--nexus-text-secondary);
}

.bar {
  display: block;
  height: 8px;
  border-radius: var(--nexus-radius-full);
  background: var(--nexus-secondary);
  overflow: hidden;
}

.fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--news-accent-fill, var(--nexus-gradient-brand-text));
}

.segmentScore {
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: var(--nexus-text-muted);
}

.placeholder {
  gap: var(--nexus-space-xs);
  border-style: dashed;
}

.hint {
  font-size: var(--nexus-text-xs);
  color: var(--nexus-text-muted);
}

@media (max-width: 768px) {
  .embed {
    padding: var(--nexus-space-lg);
  }

  .score {
    font-size: var(--nexus-text-3xl);
  }

  .scoreline {
    gap: var(--nexus-space-sm);
  }

  .side {
    flex-direction: column;
    gap: var(--nexus-space-xs);
    text-align: center;
  }

  .end {
    flex-direction: column;
    text-align: center;
  }

  .embed .segment {
    grid-template-columns: minmax(0, 1fr) 48px;
  }

  .bar {
    grid-column: 1 / -1;
    grid-row: 2;
  }
}

.profileLink {
  color: inherit;
  text-decoration: none;
  border-radius: var(--nexus-radius-sm);
}

.profileLink:hover {
  color: var(--nexus-primary);
  text-decoration: underline;
  text-underline-offset: 0.2em;
}

.profileLink:focus-visible {
  outline: 2px solid var(--nexus-border-focus);
  outline-offset: 2px;
}
